import React from 'react';
import { TWebImage } from '@types';
import classNames from 'classnames';

type Props = {
  webImage: TWebImage;
  alt: string; // Require at an alt as a default if the webImage doesn't have one
} & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const WebImage = ({ webImage, className, alt, ...props }: Props) => {
  const fullClassName = classNames(className, {
    // Preserve aspect ratio when height/width attributes are set and css is constraining the max height and/or width
    'tw:object-scale-down':
      webImage.naturalWidth &&
      webImage.naturalHeight &&
      /tw:max-[hw]/.test(className) &&
      !/tw:object/.test(className),
  });
  return (
    <img
      width={webImage.naturalWidth}
      height={webImage.naturalHeight}
      {...props}
      src={webImage.url}
      alt={webImage.altText ?? alt}
      className={fullClassName}
    />
  );
};

export default WebImage;
